import type { ReactNode } from "react";
import { tokens } from "@core/theme/tokens";
import { Icon, type IconName } from "@core/icons";

// PA-025-E (agent-logs/runs/2026-09-09-spec-211-portal/evidence/
// human-resolution-pa-025-e-duplication.json): el panel de "sin resultados"
// (círculo de ícono + título + descripción) de BenefitsScreen.tsx y
// RewardsScreen.tsx compartía exactamente el mismo marcado. Cada pantalla
// sigue componiendo sus propias acciones (botones, permisos) en `actions`,
// porque ahí es donde de verdad difieren. Extracción sin cambio de
// comportamiento ni de valores visuales.
export function EmptyResultsPanel({
  icon,
  title,
  description,
  actions,
}: {
  icon: IconName;
  title: string;
  description: string;
  actions?: ReactNode;
}) {
  return (
    <div style={{ padding: "58px 24px 66px", textAlign: "center" }}>
      <div
        style={{
          width: 54,
          height: 54,
          margin: "0 auto 16px",
          borderRadius: "50%",
          border: `1px solid ${tokens.surface.line2}`,
          background: tokens.surface.surface,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: tokens.text.tertiary,
        }}
      >
        <Icon name={icon} size={22} stroke={1.4} />
      </div>
      <h3 className="display" style={{ fontSize: 22, margin: "0 0 8px" }}>
        {title}
      </h3>
      <div
        style={{
          font: `400 13px/1.6 ${tokens.font.ui}`,
          color: tokens.text.tertiary,
          maxWidth: 430,
          margin: "0 auto 20px",
        }}
      >
        {description}
      </div>
      {actions}
    </div>
  );
}
